import React from 'react'
import Box from '@material-ui/core/Box'
import CloseIcon from '@material-ui/icons/Close'
import DialogContent from '@material-ui/core/DialogContent'
import MuiDialog from '@material-ui/core/Dialog'
import Typography from '@material-ui/core/Typography'

const Dialog = ({ heading, text, children, open, onClose }) => (
  <MuiDialog fullWidth open={open} onClose={onClose}>
    <Box py={4} px={3}>
      <Box align="right" pr={2}>
        <CloseIcon
          onClick={onClose}
          style={{ fontSize: '32px', cursor: 'pointer' }}
        />
      </Box>
      <DialogContent>
        <Box mb={4}>
          <Typography variant="h4">{heading}</Typography>
        </Box>
        {text ? <Typography variant="body1">{text}</Typography> : children}
      </DialogContent>
    </Box>
  </MuiDialog>
)

export default Dialog
